import React from 'react';

export const ErrorContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className='flex h-screen flex-col items-center justify-center bg-gray-100 p-6 dark:bg-[#18191a]'>
    {children}
  </div>
);

export const ErrorTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <h1 className='mb-4 text-2xl font-bold text-red-500 dark:text-red-400'>
    {children}
  </h1>
);

export const ErrorMessage: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <p className='max-w-[500px] text-center text-base text-gray-600 dark:text-gray-400'>
    {children}
  </p>
);

export const ErrorButton: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div className='mt-6'>{children}</div>;
